import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { NbAuthService, NbAuthJWTToken } from '@nebular/auth';
import { BaseApiService } from './base-api.service';
import { UserService } from './user.service';
import { UserModel } from './../models';

@Injectable()
export class ZAuthService {

    constructor(private authService: NbAuthService, private userService: UserService) {
    }

    private CURRENT_USER = 'current_user';

    isAuthenticated(): Observable<any> {
        return this.authService.isAuthenticated();
    }

    getCurrentUser(): Observable<UserModel> {

        return this.authService.getToken().flatMap(token => {
            const payload = (<NbAuthJWTToken>token).getPayload();
            if (payload && payload.id) {

                // const userJson = localStorage.getItem(this.CURRENT_USER);
                // if (userJson != null) {
                //     const user: UserModel = JSON.parse(userJson);
                //     if (payload.id === user.id) {
                //         return Observable.of(user);
                //     }
                // }

                return this.userService.getUser(payload.id)
                    .map(user => {
                        this.setCurrentUser(user);
                        return user;
                    });
            } else {
                return Observable.of(null);
            }
        });
    }

    setCurrentUser(user: UserModel) {
        localStorage.setItem(this.CURRENT_USER, JSON.stringify(user));
    }

    resetCurrentUser() {
        localStorage.setItem(this.CURRENT_USER, null);
    }


    isUserAdmin(user: UserModel = null): boolean {
        return this.userHasPermission('admin', user);
    }

    userHasPermission(userGroupName: String, user: UserModel = null): boolean {

        const action = (u: UserModel): boolean => {
            if (u == null || userGroupName == null || u.groups == null || u.groups.length === 0) {
                return false;
            }
            userGroupName = userGroupName.toLowerCase();
            for (const g in u.groups) {
                if (u.groups[g].name === userGroupName) {
                    return true;
                }
            }
        }

        if (user == null) {
            this.getCurrentUser().subscribe(u => action);
        } else {
            return action(user);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/services/auth.service.ts